import React from 'react';
import PropTypes from 'prop-types';
import PublicFooter from '../core/PublicFooter';
import { connect } from 'react-redux';
import { ActionContext } from './MainContainer';
import PublicAppBar from '../core/PublicAppBar';

const DefaultLayout = ({ children, useAppBar }) => {
  return (
    <div className="wrapper">
      {useAppBar && (<PublicAppBar/>)}
      <main role="main" className="flex-shrink-0 footer-offset main--content">
        <div className="container py-3">
          {children}
        </div>
      </main>
      <PublicFooter/>
    </div>
  );
};

DefaultLayout.propTypes = {
  children: PropTypes.any,
  useAppBar: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(props => (
  <ActionContext.Consumer>
    {() => (
      <DefaultLayout {...props}/>
    )}
  </ActionContext.Consumer>

));
